import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=559fdf72&scoped=true&"
import script from "./LinkList.vue?vue&type=script&lang=ts&"
export * from "./LinkList.vue?vue&type=script&lang=ts&"
import style0 from "./LinkList.vue?vue&type=style&index=0&id=559fdf72&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fdf72",
  null
  
)

export default component.exports